import React from 'react';

interface RadioButtonComponentProps {
    items: { label: string, value: string }[],
    onSelect: (value: string) => void,
    selectedValue: string | null, // ✅ controlled value từ cha
    className?: string
}

const RadioButtonComponent: React.FC<RadioButtonComponentProps> = ({
    items,
    onSelect,
    selectedValue,
    className = ''
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        onSelect(newValue); // Gọi về cha để update selectedValue
    };

    return (
        <div className={className}>
            {items.map(item => (
                <div key={item.value}>
                    <label className='mb-2 text-[15px] text-colorTxtDetailItem font-light flex items-center'>
                        <input
                            type='radio'
                            name='radio-group' // ✅ tất cả radio phải cùng name
                            value={item.value}
                            checked={selectedValue === item.value}
                            onChange={handleChange}
                            className='mr-2 custom-radio'
                        />
                        {item.label}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default RadioButtonComponent;
